var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.37,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.08 12.64V4.97L11.97.84s8.17 8.82 8.17 10.59c0 .92-3.13 1.5-3.13 1.82 0 .36-.08 1.06-.25 1.86l-1.26.7.76 1.16c-.34.96-.79 1.75-1.32 1.9l-4.1 1.1c0 1.6 1.9 3.14 2.7 3.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 6.9a3.81 3.81 0 01-4.56 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36 15.17a3.8 3.8 0 01-4.56 0"
  }))));
};

export default SvgLogo;